import type { ServerNode } from './types';
import type { ActionNodeData } from '../nodes/ActionNode';
import { ACTION_CODE_TO_FORM_TYPE, actionCodeToTitle } from '../utils/actionCodeMapping';
import { getActionStrategy } from './actionStrategies';

export function hydrateActionData(node: ServerNode): ActionNodeData {
    const { config, type } = node;
    const formType = ACTION_CODE_TO_FORM_TYPE[type];

    const base: ActionNodeData = {
        actionCode: type,
        actionType: formType ?? type,
        title: actionCodeToTitle(type) ?? 'Action',
        isPlaceholder: false,
    };

    const strategy = getActionStrategy(type);
    if (!strategy) return base;

    return { ...base, ...strategy.hydrate(config) };
}
